var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1108_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.869 80.1335C401.998 80.1335 419.936 62.195 419.936 40.0668C419.936 17.9385 401.998 0 379.869 0C357.741 0 339.803 17.9385 339.803 40.0668C339.803 62.195 357.741 80.1335 379.869 80.1335Z",
    fill: "#062134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.152 80.1335C614.28 80.1335 632.218 62.195 632.218 40.0668C632.218 17.9385 614.28 0 592.152 0C570.023 0 552.085 17.9385 552.085 40.0668C552.085 62.195 570.023 80.1335 592.152 80.1335Z",
    fill: "#062134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.529 76.5095C691.172 41.2509 654.714 20.2022 613.999 20.2022V59.9392C640.349 59.9392 663.94 73.561 677.117 96.3779C690.294 119.199 690.294 146.442 677.121 169.263L549.478 390.344C536.305 413.161 512.71 426.783 486.36 426.787C460.01 426.787 436.415 413.165 423.238 390.344L295.599 169.259C282.426 146.442 282.426 119.195 295.599 96.3779C308.772 73.561 332.371 59.9352 358.721 59.9352V20.1982C318.007 20.1982 281.544 41.2469 261.187 76.5095C240.829 111.772 240.829 153.869 261.187 189.128L388.826 410.208C405.801 439.61 433.991 459.081 466.491 464.755V571.377C466.491 675.532 405.007 760.267 329.431 760.267C253.855 760.267 192.374 675.532 192.374 571.377V444.426C237.635 435.199 271.8 395.081 271.8 347.126C271.8 292.372 227.255 247.827 172.502 247.827C117.748 247.827 73.2031 292.372 73.2031 347.126C73.2031 395.077 107.369 435.195 152.633 444.426V571.377C152.633 697.443 231.944 800.004 329.431 800.004C426.914 800.004 506.224 697.443 506.224 571.377V464.755C538.721 459.081 566.915 439.61 583.886 410.208L711.529 189.128C731.891 153.869 731.891 111.768 711.529 76.5095Z",
    fill: "#062134"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1108_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMedical);
export default __webpack_public_path__ + "static/media/ico_medical.552a3b139c096e49668b59a29b999652.svg";
export { ForwardRef as ReactComponent };